import { UserService } from "@/app/plateformebeneficiaire/core";
import { EntrepriseOptionsEnum } from "@/app/plateformebeneficiaire/core/models/enums/entrepriseOption.enum";
import { ListExternalApplicationsEnum } from "@/app/plateformebeneficiaire/core/models/enums/listExternalApplications.enum";
import { EntrepriseOptionService } from "@/app/plateformebeneficiaire/core/service/entrepriseOption.service";
import { ExternalApplicationsUtils } from "@/app/plateformebeneficiaire/core/utils/externalApplications.utils";
import { CommonModule } from "@angular/common";
import { Component, computed, inject, signal } from "@angular/core";
import { RouterModule } from "@angular/router";
import { ButtonModule } from "primeng/button";
import { CreateExternalLinkDialogComponent } from "../create-external-link-dialog/create-external-link-dialog.component";

@Component({
  selector: 'app-myprofile-box',
  imports: [
    CommonModule,
    ButtonModule,
    RouterModule,
    CreateExternalLinkDialogComponent
  ],
  templateUrl: './myprofile-box.component.html',
  styleUrl: './myprofile-box.component.scss',
  standalone: true
})
export class MyProfileBoxComponent {
  selectedApp = '';
  displayModal = false;
  // constructor(private messageService: MessageService, private sanitizer: DomSanitizer) {}

  // siteId = model<string>('');
  // intervenantId = model<string>('');
  // typeRdvId = model<string>('');
  // horaire = signal<string>('');
  
  readonly #userService = inject(UserService);
  readonly #externalApplicationsUtils = inject(ExternalApplicationsUtils);

  readonly #userInfoQuery = this.#userService.getUserInfos();
  readonly #entrepriseOptionsService = inject(EntrepriseOptionService);
  readonly #entrepriseOptionsQuery = this.#entrepriseOptionsService.listEntrepriseOptions();
  entrepriseOptions = computed(() => this.#entrepriseOptionsQuery.data() ?? []);
  
  externalApplications = computed(
    () => {
      let x = this.#entrepriseOptionsQuery.data()?.find(
        (x: any) => x.key == EntrepriseOptionsEnum.ListExternalLinks
      )?.value ?? "[]";
      return JSON.parse(x);
    })
  isLoadingEntrepriseOptions = computed(() => this.#entrepriseOptionsQuery.isLoading());
    
  filteredApplications = computed(() => {
    const enabledApps = this.externalApplications();
    const userLinks = this.#userInfoQuery.data()?.externalLinks ?? [];

    return Object.values(ListExternalApplicationsEnum)
      .filter(key => enabledApps.includes(key))
      .map(key => {
        const { name, description } = this.#externalApplicationsUtils.getDisplayValue(key);
        const externalLink = userLinks.find(link => link.system === key);
        return {
          name,
          key,
          description,
          folderNumber: externalLink?.external_dossier_id || null,
          connected: !!externalLink
        };
      });
  });
  
  getInitials(name: string): string {
    return name
      .split(/\s+/)
      .filter(w => w.length > 0)
      .map(w => w[0].toUpperCase())
      .slice(0, 2)
      .join('');
  }

  connect(app: any) {
    this.selectedApp = app.key;
    this.displayModal = true;
  }
  onCancelled() {
    this.displayModal = false;
    this.selectedApp = '';
  }
  onCreated(event: any) {
    alert('ok on created');
  }
}
